import { render, staticRenderFns } from "./EmployeeMovementFloatBtns.vue?vue&type=template&id=28f880f6&"
import script from "./EmployeeMovementFloatBtns.vue?vue&type=script&lang=js&"
export * from "./EmployeeMovementFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports